import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { PropertyUnit } from '@/lib/units';

interface UnitNavigationProps {
  previousUnit: PropertyUnit | null;
  nextUnit: PropertyUnit | null;
  onNavigate: (unitNumber: string) => void;
}

export const UnitNavigation = ({ previousUnit, nextUnit, onNavigate }: UnitNavigationProps) => {
  // Don't render if both are null (only one unit or no units)
  if (!previousUnit && !nextUnit) {
    return null;
  }

  return (
    <div className="fixed bottom-[70px] lg:bottom-0 left-0 right-0 z-[55] bg-background/80 backdrop-blur-md border-t border-border shadow-lg">
      {/* On mobile, position above StickyMobileCTA (approx 70px height) */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto py-3 sm:py-4">
          <div className="flex items-center justify-between gap-4">
            {/* Previous Unit Button */}
            <Button
              variant="outline"
              size="lg"
              className={cn(
                "flex-1 sm:flex-initial gap-2 transition-all",
                !previousUnit && "opacity-50 cursor-not-allowed"
              )}
              onClick={() => previousUnit && onNavigate(previousUnit.unit_number)}
              disabled={!previousUnit}
            >
              <ChevronLeft className="w-5 h-5" />
              <span className="hidden sm:inline">Previous</span>
              {previousUnit && (
                <span className="font-semibold">Unit {previousUnit.unit_number}</span>
              )}
            </Button>

            {/* Next Unit Button */}
            <Button
              variant="outline"
              size="lg"
              className={cn(
                "flex-1 sm:flex-initial gap-2 transition-all",
                !nextUnit && "opacity-50 cursor-not-allowed"
              )}
              onClick={() => nextUnit && onNavigate(nextUnit.unit_number)}
              disabled={!nextUnit}
            >
              {nextUnit && (
                <span className="font-semibold">Unit {nextUnit.unit_number}</span>
              )}
              <span className="hidden sm:inline">Next</span>
              <ChevronRight className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
